export const MockForemanId = 'MockForemanId';
export const MockGeneralForemanId = 'MockGeneralForemanId';
export const MockSuperintendentId = 'MockSuperintendentId';

export interface CrewChangeRequestProps {
  closeSideSheet: (successs: boolean, id?: string) => void;
}
